export const SCHREIBEN_TASKS = [
  {
    "id": "schreiben-teil1",
    "teil": 1,
    "title": "Teil 1 — Forumsbeitrag",
    "arbeitzeit": "Teil 1 vorgeschlagene Arbeitszeit: 50 Minuten",
    "timeMinutes": 50,
    "wordTarget": {
      "min": 150,
      "max": 250
    },
    "prompt": {
      "intro": "Sie schreiben einen Forumsbeitrag zur Verschmutzung der Umwelt.",
      "bulletPoints": [
        "Äußern Sie Ihre Meinung zu Plastikverpackungen im Alltag.",
        "Nennen Sie Gründe, warum Plastikverpackungen so verbreitet sind.",
        "Nennen Sie andere Möglichkeiten, Dinge im Alltag zu verpacken.",
        "Nennen Sie Vorteile der anderen Verpackungen."
      ],
      "bewertung": "Denken Sie an eine Einleitung und einen Schluss. Bei der Bewertung wird darauf geachtet, wie genau die Inhaltspunkte bearbeitet sind, wie korrekt der Text ist und wie gut die Sätze und Abschnitte sprachlich miteinander verknüpft sind.",
      "wordNote": "Schreiben Sie circa 150 Wörter."
    },
    "rubric": [
      {
        "id": "aufgabe",
        "label": "Aufgabe erfüllt",
        "weight": 25
      },
      {
        "id": "struktur",
        "label": "Struktur & Kohärenz",
        "weight": 25
      },
      {
        "id": "wortschatz",
        "label": "Wortschatz",
        "weight": 25
      },
      {
        "id": "grammatik",
        "label": "Grammatik & Orthografie",
        "weight": 25
      }
    ]
  },
  {
    "id": "schreiben-teil2",
    "teil": 2,
    "title": "Teil 2 — Nachricht an Vorgesetzten",
    "arbeitzeit": "Teil 2 vorgeschlagene Arbeitszeit: 25 Minuten",
    "timeMinutes": 25,
    "wordTarget": {
      "min": 100,
      "max": 200
    },
    "prompt": {
      "intro": "Sie machen gerade ein Praktikum bei einer deutschen Firma. Sie haben derzeit so viel zu tun, dass Sie Ihre Arbeit nicht mehr schaffen. Schreiben Sie eine Nachricht an Ihren Vorgesetzten, Herrn Ebert.",
      "bulletPoints": [
        "Beschreiben Sie, womit Sie beschäftigt sind.",
        "Bitten Sie um Verständnis für Ihre Situation.",
        "Machen Sie einen Vorschlag für die kommenden Tage.",
        "Zeigen Sie Verständnis für die Arbeitssituation in der Firma."
      ],
      "hinweis": "Überlegen Sie sich eine passende Reihenfolge für die Inhaltspunkte.",
      "bewertung": "Bei der Bewertung wird darauf geachtet, wie genau die Inhaltspunkte bearbeitet sind, wie korrekt der Text ist und wie gut die Sätze und Abschnitte sprachlich miteinander verknüpft sind. Vergessen Sie nicht Anrede und Gruß.",
      "wordNote": "Schreiben Sie circa 100 Wörter."
    },
    "rubric": [
      {
        "id": "register",
        "label": "Formeller Stil (Sie)",
        "weight": 30
      },
      {
        "id": "inhalt",
        "label": "Alle Punkte behandelt",
        "weight": 30
      },
      {
        "id": "struktur",
        "label": "Klare Struktur",
        "weight": 20
      },
      {
        "id": "sprache",
        "label": "Sprachliche Korrektheit",
        "weight": 20
      }
    ]
  }
];
